// Achievement names and descriptions, keyed by achievement_key (the same 28 keys as the Play
// Games catalog in pgsAchievementMap.ts). Generated from pgs-achievements-import/full-import by
// scripts/gen-achievement-content.py; five badges carry concrete in-app rules instead of the
// Play Games marketing text. The database holds English only; AchievementsScreen uses these.
export const achievementContent = {
  en: {
    first_quiz_name: 'First Quiz Completed',
    first_quiz_description: 'Complete your very first Bible quiz. Every journey through Scripture begins with a single step!',
    quiz_10_name: 'Quiz Enthusiast',
    quiz_10_description: 'Complete 10 Bible quizzes. Your dedication to learning God\'s Word is growing!',
    quiz_50_name: 'Quiz Veteran',
    quiz_50_description: 'Complete 50 Bible quizzes. You are becoming a true student of the Word!',
    quiz_100_name: 'Quiz Centurion',
    quiz_100_description: 'Complete 100 Bible quizzes. Your commitment to Scripture is truly remarkable!',
    quiz_500_name: 'Quiz Legend',
    quiz_500_description: 'Complete 500 Bible quizzes. You are a legendary Bible scholar!',
    perfect_score_name: 'Perfect Score',
    perfect_score_description: 'Answer every question correctly in a single quiz. Flawless victory!',
    perfect_10_name: 'Perfection Seeker',
    perfect_10_description: 'Achieve 10 perfect scores across any quizzes. Mastery through precision!',
    knowledge_100_name: 'Knowledge Builder',
    knowledge_100_description: 'Answer 100 questions correctly. Building your biblical knowledge!',
    knowledge_1000_name: 'Knowledge Master',
    knowledge_1000_description: 'Answer 1000 questions correctly. A true master of biblical knowledge!',
    truth_seeker_name: 'Truth Seeker',
    truth_seeker_description: 'Answer 25 True/False questions correctly.',
    binary_master_name: 'Binary Master',
    binary_master_description: 'Get every True/False question right in a quiz with at least 5 of them.',
    lightning_judge_name: 'Lightning Judge',
    lightning_judge_description: 'Finish a 10-question quiz in under 2 minutes with 8 or more correct.',
    discernment_expert_name: 'Discernment Expert',
    discernment_expert_description: 'Answer 25 multi-select questions correctly.',
    wisdom_seeker_name: 'Wisdom Seeker',
    wisdom_seeker_description: 'Complete 10 Hard quizzes with 80% or better.',
    streak_7_name: 'Streak Starter',
    streak_7_description: 'Maintain a 7-day quiz streak. Consistency is key!',
    streak_30_name: 'Streak Master',
    streak_30_description: 'Reach a 30-day quiz streak. A month of daily devotion to the Word!',
    streak_100_name: 'Streak Legend',
    streak_100_description: 'Reach a 100-day streak. Your daily commitment to Scripture is extraordinary!',
    explorer_5_name: 'Explorer',
    explorer_5_description: 'Play quizzes across 5 different Bible categories. Exploring all of Scripture!',
    explorer_20_name: 'Bible Explorer',
    explorer_20_description: 'Play quizzes across 20 different categories. A true explorer of God\'s Word!',
    multiplayer_first_name: 'Multiplayer Debut',
    multiplayer_first_description: 'Complete your first multiplayer Bible quiz. Iron sharpens iron!',
    multiplayer_winner_name: 'Multiplayer Champion',
    multiplayer_winner_description: 'Win a multiplayer quiz by finishing in first place!',
    multiplayer_10_name: 'Multiplayer Veteran',
    multiplayer_10_description: 'Complete 10 multiplayer quizzes. A seasoned competitor in biblical knowledge!',
    level_10_name: 'Rising Scholar',
    level_10_description: 'Reach level 10. Your growth in biblical knowledge is impressive!',
    level_25_name: 'Master Scholar',
    level_25_description: 'Reach level 25. You have achieved true scholarly status!',
    xp_1000_name: 'XP Milestone',
    xp_1000_description: 'Earn 1000 total XP through quizzes and challenges!',
    xp_10000_name: 'XP Legend',
    xp_10000_description: 'Earn 10000 total XP. A legendary amount of biblical learning!',
    scholar_rank_name: 'Scholar Rank',
    scholar_rank_description: 'Achieve the Scholar rank through dedication and knowledge!',
    polyglot_3_name: 'Polyglot',
    polyglot_3_description: 'Play quizzes in 3 different languages. The Word transcends all tongues!',
  },
  fr: {
    first_quiz_name: 'Premier Quiz Terminé',
    first_quiz_description: 'Complétez votre tout premier quiz biblique. Chaque voyage à travers les Écritures commence par un seul pas!',
    quiz_10_name: 'Passionné du Quiz',
    quiz_10_description: 'Complétez 10 quiz bibliques. Votre dévouement à la Parole de Dieu grandit!',
    quiz_50_name: 'Vétéran du Quiz',
    quiz_50_description: 'Complétez 50 quiz bibliques. Vous devenez un véritable étudiant de la Parole!',
    quiz_100_name: 'Centurion du Quiz',
    quiz_100_description: 'Complétez 100 quiz bibliques. Votre engagement envers les Écritures est remarquable!',
    quiz_500_name: 'Légende du Quiz',
    quiz_500_description: 'Complétez 500 quiz bibliques. Vous êtes un érudit biblique légendaire!',
    perfect_score_name: 'Score Parfait',
    perfect_score_description: 'Répondez correctement à toutes les questions d\'un quiz. Victoire parfaite!',
    perfect_10_name: 'Chercheur de Perfection',
    perfect_10_description: 'Obtenez 10 scores parfaits dans n\'importe quel quiz. Maîtrise par la précision!',
    knowledge_100_name: 'Bâtisseur de Connaissances',
    knowledge_100_description: 'Répondez correctement à 100 questions. Construisez votre savoir biblique!',
    knowledge_1000_name: 'Maître du Savoir',
    knowledge_1000_description: 'Répondez correctement à 1000 questions. Un vrai maître du savoir biblique!',
    truth_seeker_name: 'Chercheur de vérité',
    truth_seeker_description: 'Répondez correctement à 25 questions Vrai/Faux.',
    binary_master_name: 'Maître du binaire',
    binary_master_description: 'Réussissez toutes les questions Vrai/Faux d\'un quiz qui en contient au moins 5.',
    lightning_judge_name: 'Juge éclair',
    lightning_judge_description: 'Terminez un quiz de 10 questions en moins de 2 minutes avec au moins 8 bonnes réponses.',
    discernment_expert_name: 'Expert en discernement',
    discernment_expert_description: 'Répondez correctement à 25 questions à choix multiples.',
    wisdom_seeker_name: 'Chercheur de sagesse',
    wisdom_seeker_description: 'Terminez 10 quiz Difficiles avec 80 % ou plus.',
    streak_7_name: 'Début de Série',
    streak_7_description: 'Maintenez une série de 7 jours de quiz. La constance est la clé!',
    streak_30_name: 'Maître de Série',
    streak_30_description: 'Atteignez une série de 30 jours. Un mois de dévotion quotidienne à la Parole!',
    streak_100_name: 'Légende de Série',
    streak_100_description: 'Atteignez une série de 100 jours. Votre engagement quotidien est extraordinaire!',
    explorer_5_name: 'Explorateur',
    explorer_5_description: 'Jouez des quiz dans 5 catégories bibliques différentes. Explorez toute l\'Écriture!',
    explorer_20_name: 'Explorateur Biblique',
    explorer_20_description: 'Jouez des quiz dans 20 catégories différentes. Un véritable explorateur de la Parole!',
    multiplayer_first_name: 'Début Multijoueur',
    multiplayer_first_description: 'Complétez votre premier quiz biblique multijoueur. Le fer aiguise le fer!',
    multiplayer_winner_name: 'Champion Multijoueur',
    multiplayer_winner_description: 'Gagnez un quiz multijoueur en terminant premier!',
    multiplayer_10_name: 'Vétéran Multijoueur',
    multiplayer_10_description: 'Complétez 10 quiz multijoueurs. Un compétiteur expérimenté en savoir biblique!',
    level_10_name: 'Érudit en Devenir',
    level_10_description: 'Atteignez le niveau 10. Votre croissance en savoir biblique est impressionnante!',
    level_25_name: 'Maître Érudit',
    level_25_description: 'Atteignez le niveau 25. Vous avez atteint un véritable statut d\'érudit!',
    xp_1000_name: 'Jalon XP',
    xp_1000_description: 'Gagnez 1000 XP au total à travers les quiz et les défis!',
    xp_10000_name: 'Légende XP',
    xp_10000_description: 'Gagnez 10000 XP au total. Une quantité légendaire d\'apprentissage biblique!',
    scholar_rank_name: 'Rang d\'Érudit',
    scholar_rank_description: 'Atteignez le rang d\'Érudit par la dévotion et la connaissance!',
    polyglot_3_name: 'Polyglotte',
    polyglot_3_description: 'Jouez des quiz dans 3 langues différentes. La Parole transcende toutes les langues!',
  },
  es: {
    first_quiz_name: 'Primer Quiz Completado',
    first_quiz_description: 'Completa tu primer quiz bíblico. ¡Todo viaje por las Escrituras comienza con un solo paso!',
    quiz_10_name: 'Entusiasta del Quiz',
    quiz_10_description: 'Completa 10 quizzes bíblicos. ¡Tu dedicación a la Palabra de Dios está creciendo!',
    quiz_50_name: 'Veterano del Quiz',
    quiz_50_description: 'Completa 50 quizzes bíblicos. ¡Te estás convirtiendo en un verdadero estudiante de la Palabra!',
    quiz_100_name: 'Centurión del Quiz',
    quiz_100_description: 'Completa 100 quizzes bíblicos. ¡Tu compromiso con las Escrituras es verdaderamente notable!',
    quiz_500_name: 'Leyenda del Quiz',
    quiz_500_description: 'Completa 500 quizzes bíblicos. ¡Eres un erudito bíblico legendario!',
    perfect_score_name: 'Puntuación Perfecta',
    perfect_score_description: 'Responde correctamente a todas las preguntas en un solo quiz. ¡Victoria impecable!',
    perfect_10_name: 'Buscador de Perfección',
    perfect_10_description: 'Logra 10 puntuaciones perfectas en cualquier quiz. ¡Dominio a través de la precisión!',
    knowledge_100_name: 'Constructor de Conocimiento',
    knowledge_100_description: 'Responde 100 preguntas correctamente. ¡Construyendo tu conocimiento bíblico!',
    knowledge_1000_name: 'Maestro del Conocimiento',
    knowledge_1000_description: 'Responde 1000 preguntas correctamente. ¡Un verdadero maestro del conocimiento bíblico!',
    truth_seeker_name: 'Buscador de la verdad',
    truth_seeker_description: 'Responde correctamente 25 preguntas de verdadero/falso.',
    binary_master_name: 'Maestro binario',
    binary_master_description: 'Acierta todas las preguntas de verdadero/falso en un quiz con al menos 5.',
    lightning_judge_name: 'Juez relámpago',
    lightning_judge_description: 'Termina un quiz de 10 preguntas en menos de 2 minutos con 8 o más aciertos.',
    discernment_expert_name: 'Experto en discernimiento',
    discernment_expert_description: 'Responde correctamente 25 preguntas de selección múltiple.',
    wisdom_seeker_name: 'Buscador de sabiduría',
    wisdom_seeker_description: 'Completa 10 quizzes Difíciles con 80 % o más.',
    streak_7_name: 'Inicio de Racha',
    streak_7_description: 'Mantén una racha de 7 días de quizzes. ¡La constancia es clave!',
    streak_30_name: 'Maestro de Racha',
    streak_30_description: 'Alcanza una racha de 30 días. ¡Un mes de devoción diaria a la Palabra!',
    streak_100_name: 'Leyenda de Racha',
    streak_100_description: 'Alcanza una racha de 100 días. ¡Tu compromiso diario con las Escrituras es extraordinario!',
    explorer_5_name: 'Explorador',
    explorer_5_description: 'Juega quizzes en 5 categorías bíblicas diferentes. ¡Explorando toda la Escritura!',
    explorer_20_name: 'Explorador Bíblico',
    explorer_20_description: 'Juega quizzes en 20 categorías diferentes. ¡Un verdadero explorador de la Palabra de Dios!',
    multiplayer_first_name: 'Debut Multijugador',
    multiplayer_first_description: 'Completa tu primer quiz bíblico multijugador. ¡El hierro con hierro se afila!',
    multiplayer_winner_name: 'Campeón Multijugador',
    multiplayer_winner_description: '¡Gana un quiz multijugador terminando en primer lugar!',
    multiplayer_10_name: 'Veterano Multijugador',
    multiplayer_10_description: 'Completa 10 quizzes multijugador. ¡Un competidor experimentado en conocimiento bíblico!',
    level_10_name: 'Erudito en Ascenso',
    level_10_description: 'Alcanza el nivel 10. ¡Tu crecimiento en conocimiento bíblico es impresionante!',
    level_25_name: 'Erudito Maestro',
    level_25_description: 'Alcanza el nivel 25. ¡Has alcanzado un verdadero estatus de erudito!',
    xp_1000_name: 'Hito de XP',
    xp_1000_description: '¡Gana 1000 XP totales a través de quizzes y desafíos!',
    xp_10000_name: 'Leyenda de XP',
    xp_10000_description: '¡Gana 10000 XP totales. Una cantidad legendaria de aprendizaje bíblico!',
    scholar_rank_name: 'Rango de Erudito',
    scholar_rank_description: '¡Alcanza el rango de Erudito a través de la dedicación y el conocimiento!',
    polyglot_3_name: 'Políglota',
    polyglot_3_description: 'Juega quizzes en 3 idiomas diferentes. ¡La Palabra trasciende todas las lenguas!',
  },
  de: {
    first_quiz_name: 'Erstes Quiz Abgeschlossen',
    first_quiz_description: 'Schließe dein allererstes Bibelquiz ab. Jede Reise durch die Schrift beginnt mit einem Schritt!',
    quiz_10_name: 'Quiz-Enthusiast',
    quiz_10_description: 'Schließe 10 Bibelquizze ab. Dein Eifer für Gottes Wort wächst!',
    quiz_50_name: 'Quiz-Veteran',
    quiz_50_description: 'Schließe 50 Bibelquizze ab. Du wirst ein wahrer Schüler des Wortes!',
    quiz_100_name: 'Quiz-Zenturio',
    quiz_100_description: 'Schließe 100 Bibelquizze ab. Dein Engagement für die Schrift ist bemerkenswert!',
    quiz_500_name: 'Quiz-Legende',
    quiz_500_description: 'Schließe 500 Bibelquizze ab. Du bist ein legendärer Bibelgelehrter!',
    perfect_score_name: 'Perfekte Punktzahl',
    perfect_score_description: 'Beantworte alle Fragen in einem Quiz richtig. Makelloser Sieg!',
    perfect_10_name: 'Perfektionssucher',
    perfect_10_description: 'Erreiche 10 perfekte Punktzahlen in beliebigen Quizzen. Meisterschaft durch Präzision!',
    knowledge_100_name: 'Wissensbauer',
    knowledge_100_description: 'Beantworte 100 Fragen richtig. Baue dein biblisches Wissen auf!',
    knowledge_1000_name: 'Wissensmeister',
    knowledge_1000_description: 'Beantworte 1000 Fragen richtig. Ein wahrer Meister des biblischen Wissens!',
    truth_seeker_name: 'Wahrheitssucher',
    truth_seeker_description: 'Beantworte 25 Wahr/Falsch-Fragen richtig.',
    binary_master_name: 'Binär-Meister',
    binary_master_description: 'Beantworte in einem Quiz mit mindestens 5 Wahr/Falsch-Fragen alle richtig.',
    lightning_judge_name: 'Blitz-Richter',
    lightning_judge_description: 'Beende ein Quiz mit 10 Fragen in unter 2 Minuten mit mindestens 8 richtigen Antworten.',
    discernment_expert_name: 'Experte der Unterscheidung',
    discernment_expert_description: 'Beantworte 25 Mehrfachauswahl-Fragen richtig.',
    wisdom_seeker_name: 'Weisheitssucher',
    wisdom_seeker_description: 'Schließe 10 schwere Quizze mit mindestens 80 % ab.',
    streak_7_name: 'Serienstart',
    streak_7_description: 'Halte eine 7-Tage-Quiz-Serie aufrecht. Beständigkeit ist der Schlüssel!',
    streak_30_name: 'Serienmeister',
    streak_30_description: 'Erreiche eine 30-Tage-Serie. Ein Monat täglicher Hingabe an das Wort!',
    streak_100_name: 'Serienlegende',
    streak_100_description: 'Erreiche eine 100-Tage-Serie. Dein tägliches Engagement ist außergewöhnlich!',
    explorer_5_name: 'Entdecker',
    explorer_5_description: 'Spiele Quizze in 5 verschiedenen Bibelkategorien. Erkunde die gesamte Schrift!',
    explorer_20_name: 'Bibel-Entdecker',
    explorer_20_description: 'Spiele Quizze in 20 verschiedenen Kategorien. Ein wahrer Entdecker des Wortes Gottes!',
    multiplayer_first_name: 'Mehrspieler-Debüt',
    multiplayer_first_description: 'Schließe dein erstes Mehrspieler-Bibelquiz ab. Eisen schärft Eisen!',
    multiplayer_winner_name: 'Mehrspieler-Champion',
    multiplayer_winner_description: 'Gewinne ein Mehrspieler-Quiz als Erstplatzierter!',
    multiplayer_10_name: 'Mehrspieler-Veteran',
    multiplayer_10_description: 'Schließe 10 Mehrspieler-Quizze ab. Ein erfahrener Wettbewerber!',
    level_10_name: 'Aufsteigender Gelehrter',
    level_10_description: 'Erreiche Level 10. Dein Wachstum im biblischen Wissen ist beeindruckend!',
    level_25_name: 'Meistergelehrter',
    level_25_description: 'Erreiche Level 25. Du hast wahren Gelehrtenstatus erreicht!',
    xp_1000_name: 'XP-Meilenstein',
    xp_1000_description: 'Verdiene insgesamt 1000 XP durch Quizze und Herausforderungen!',
    xp_10000_name: 'XP-Legende',
    xp_10000_description: 'Verdiene insgesamt 10000 XP. Eine legendäre Menge an biblischem Lernen!',
    scholar_rank_name: 'Gelehrtenrang',
    scholar_rank_description: 'Erreiche den Gelehrtenrang durch Hingabe und Wissen!',
    polyglot_3_name: 'Polyglott',
    polyglot_3_description: 'Spiele Quizze in 3 verschiedenen Sprachen. Das Wort überwindet alle Grenzen!',
  },
  pt: {
    first_quiz_name: 'Primeiro Quiz Concluído',
    first_quiz_description: 'Complete seu primeiro quiz bíblico. Toda jornada pelas Escrituras começa com um único passo!',
    quiz_10_name: 'Entusiasta do Quiz',
    quiz_10_description: 'Complete 10 quizzes bíblicos. Sua dedicação à Palavra de Deus está crescendo!',
    quiz_50_name: 'Veterano do Quiz',
    quiz_50_description: 'Complete 50 quizzes bíblicos. Você está se tornando um verdadeiro estudante da Palavra!',
    quiz_100_name: 'Centurião do Quiz',
    quiz_100_description: 'Complete 100 quizzes bíblicos. Seu compromisso com as Escrituras é notável!',
    quiz_500_name: 'Lenda do Quiz',
    quiz_500_description: 'Complete 500 quizzes bíblicos. Você é um estudioso bíblico lendário!',
    perfect_score_name: 'Pontuação Perfeita',
    perfect_score_description: 'Acerte todas as perguntas em um único quiz. Vitória impecável!',
    perfect_10_name: 'Buscador da Perfeição',
    perfect_10_description: 'Alcance 10 pontuações perfeitas em quaisquer quizzes. Maestria pela precisão!',
    knowledge_100_name: 'Construtor de Conhecimento',
    knowledge_100_description: 'Responda 100 perguntas corretamente. Construindo seu conhecimento bíblico!',
    knowledge_1000_name: 'Mestre do Conhecimento',
    knowledge_1000_description: 'Responda 1000 perguntas corretamente. Um verdadeiro mestre do conhecimento bíblico!',
    truth_seeker_name: 'Buscador da verdade',
    truth_seeker_description: 'Responda corretamente a 25 perguntas de verdadeiro/falso.',
    binary_master_name: 'Mestre binário',
    binary_master_description: 'Acerte todas as perguntas de verdadeiro/falso em um quiz com pelo menos 5 delas.',
    lightning_judge_name: 'Juiz relâmpago',
    lightning_judge_description: 'Conclua um quiz de 10 perguntas em menos de 2 minutos com 8 ou mais acertos.',
    discernment_expert_name: 'Especialista em discernimento',
    discernment_expert_description: 'Responda corretamente a 25 perguntas de múltipla seleção.',
    wisdom_seeker_name: 'Buscador de sabedoria',
    wisdom_seeker_description: 'Conclua 10 quizzes Difíceis com 80% ou mais.',
    streak_7_name: 'Início de Sequência',
    streak_7_description: 'Mantenha uma sequência de 7 dias de quizzes. Consistência é a chave!',
    streak_30_name: 'Mestre da Sequência',
    streak_30_description: 'Alcance uma sequência de 30 dias. Um mês de devoção diária à Palavra!',
    streak_100_name: 'Lenda da Sequência',
    streak_100_description: 'Alcance uma sequência de 100 dias. Seu compromisso diário é extraordinário!',
    explorer_5_name: 'Explorador',
    explorer_5_description: 'Jogue quizzes em 5 categorias bíblicas diferentes. Explorando toda a Escritura!',
    explorer_20_name: 'Explorador Bíblico',
    explorer_20_description: 'Jogue quizzes em 20 categorias diferentes. Um verdadeiro explorador da Palavra de Deus!',
    multiplayer_first_name: 'Estreia Multijogador',
    multiplayer_first_description: 'Complete seu primeiro quiz bíblico multijogador. Ferro com ferro se afia!',
    multiplayer_winner_name: 'Campeão Multijogador',
    multiplayer_winner_description: 'Vença um quiz multijogador terminando em primeiro lugar!',
    multiplayer_10_name: 'Veterano Multijogador',
    multiplayer_10_description: 'Complete 10 quizzes multijogador. Um competidor experiente em conhecimento bíblico!',
    level_10_name: 'Estudioso em Ascensão',
    level_10_description: 'Alcance o nível 10. Seu crescimento em conhecimento bíblico é impressionante!',
    level_25_name: 'Mestre Estudioso',
    level_25_description: 'Alcance o nível 25. Você alcançou verdadeiro status de estudioso!',
    xp_1000_name: 'Marco de XP',
    xp_1000_description: 'Ganhe 1000 XP no total através de quizzes e desafios!',
    xp_10000_name: 'Lenda de XP',
    xp_10000_description: 'Ganhe 10000 XP no total. Uma quantidade lendária de aprendizado bíblico!',
    scholar_rank_name: 'Posto de Estudioso',
    scholar_rank_description: 'Alcance o posto de Estudioso através de dedicação e conhecimento!',
    polyglot_3_name: 'Poliglota',
    polyglot_3_description: 'Jogue quizzes em 3 idiomas diferentes. A Palavra transcende todas as línguas!',
  },
  ru: {
    first_quiz_name: 'Первый Квиз Пройден',
    first_quiz_description: 'Пройдите свой первый библейский квиз. Каждое путешествие по Писанию начинается с первого шага!',
    quiz_10_name: 'Энтузиаст Квизов',
    quiz_10_description: 'Пройдите 10 библейских квизов. Ваша преданность Слову Божьему растёт!',
    quiz_50_name: 'Ветеран Квизов',
    quiz_50_description: 'Пройдите 50 библейских квизов. Вы становитесь настоящим учеником Слова!',
    quiz_100_name: 'Центурион Квизов',
    quiz_100_description: 'Пройдите 100 библейских квизов. Ваша приверженность Писанию замечательна!',
    quiz_500_name: 'Легенда Квизов',
    quiz_500_description: 'Пройдите 500 библейских квизов. Вы легендарный знаток Библии!',
    perfect_score_name: 'Идеальный Результат',
    perfect_score_description: 'Ответьте правильно на все вопросы в одном квизе. Безупречная победа!',
    perfect_10_name: 'Искатель Совершенства',
    perfect_10_description: 'Достигните 10 идеальных результатов. Мастерство через точность!',
    knowledge_100_name: 'Строитель Знаний',
    knowledge_100_description: 'Ответьте правильно на 100 вопросов. Строите своё библейское знание!',
    knowledge_1000_name: 'Мастер Знаний',
    knowledge_1000_description: 'Ответьте правильно на 1000 вопросов. Настоящий мастер библейских знаний!',
    truth_seeker_name: 'Искатель истины',
    truth_seeker_description: 'Правильно ответьте на 25 вопросов «верно/неверно».',
    binary_master_name: 'Мастер бинарных вопросов',
    binary_master_description: 'Ответьте верно на все вопросы «верно/неверно» в викторине, где их не меньше 5.',
    lightning_judge_name: 'Молниеносный судья',
    lightning_judge_description: 'Пройдите викторину из 10 вопросов быстрее чем за 2 минуты с 8 и более верными ответами.',
    discernment_expert_name: 'Эксперт различения',
    discernment_expert_description: 'Правильно ответьте на 25 вопросов с несколькими верными ответами.',
    wisdom_seeker_name: 'Искатель мудрости',
    wisdom_seeker_description: 'Пройдите 10 сложных викторин с результатом 80% и выше.',
    streak_7_name: 'Начало Серии',
    streak_7_description: 'Поддерживайте серию квизов в течение 7 дней. Постоянство — ключ к успеху!',
    streak_30_name: 'Мастер Серии',
    streak_30_description: 'Достигните серии в 30 дней. Месяц ежедневного посвящения Слову!',
    streak_100_name: 'Легенда Серии',
    streak_100_description: 'Достигните серии в 100 дней. Ваша ежедневная преданность необычайна!',
    explorer_5_name: 'Исследователь',
    explorer_5_description: 'Играйте квизы в 5 разных библейских категориях. Исследуйте всё Писание!',
    explorer_20_name: 'Библейский Исследователь',
    explorer_20_description: 'Играйте квизы в 20 разных категориях. Настоящий исследователь Слова Божьего!',
    multiplayer_first_name: 'Мультиплеер Дебют',
    multiplayer_first_description: 'Пройдите свой первый мультиплеерный библейский квиз. Железо точит железо!',
    multiplayer_winner_name: 'Чемпион Мультиплеера',
    multiplayer_winner_description: 'Выиграйте мультиплеерный квиз заняв первое место!',
    multiplayer_10_name: 'Ветеран Мультиплеера',
    multiplayer_10_description: 'Пройдите 10 мультиплеерных квизов. Опытный соперник в библейских знаниях!',
    level_10_name: 'Восходящий Учёный',
    level_10_description: 'Достигните уровня 10. Ваш рост в библейских знаниях впечатляет!',
    level_25_name: 'Учёный Мастер',
    level_25_description: 'Достигните уровня 25. Вы достигли настоящего статуса учёного!',
    xp_1000_name: 'Веха XP',
    xp_1000_description: 'Заработайте 1000 XP через квизы и испытания!',
    xp_10000_name: 'Легенда XP',
    xp_10000_description: 'Заработайте 10000 XP. Легендарное количество библейского обучения!',
    scholar_rank_name: 'Ранг Учёного',
    scholar_rank_description: 'Достигните ранга Учёного через преданность и знания!',
    polyglot_3_name: 'Полиглот',
    polyglot_3_description: 'Играйте квизы на 3 разных языках. Слово превосходит все языки!',
  },
  it: {
    first_quiz_name: 'Primo Quiz Completato',
    first_quiz_description: 'Completa il tuo primo quiz biblico. Ogni viaggio attraverso le Scritture inizia con un singolo passo!',
    quiz_10_name: 'Appassionato di Quiz',
    quiz_10_description: 'Completa 10 quiz biblici. La tua dedizione alla Parola di Dio sta crescendo!',
    quiz_50_name: 'Veterano del Quiz',
    quiz_50_description: 'Completa 50 quiz biblici. Stai diventando un vero studente della Parola!',
    quiz_100_name: 'Centurione del Quiz',
    quiz_100_description: 'Completa 100 quiz biblici. Il tuo impegno verso le Scritture è notevole!',
    quiz_500_name: 'Leggenda del Quiz',
    quiz_500_description: 'Completa 500 quiz biblici. Sei un leggendario studioso della Bibbia!',
    perfect_score_name: 'Punteggio Perfetto',
    perfect_score_description: 'Rispondi correttamente a tutte le domande in un quiz. Vittoria impeccabile!',
    perfect_10_name: 'Cercatore di Perfezione',
    perfect_10_description: 'Ottieni 10 punteggi perfetti in qualsiasi quiz. Padronanza attraverso la precisione!',
    knowledge_100_name: 'Costruttore di Conoscenza',
    knowledge_100_description: 'Rispondi correttamente a 100 domande. Costruisci la tua conoscenza biblica!',
    knowledge_1000_name: 'Maestro della Conoscenza',
    knowledge_1000_description: 'Rispondi correttamente a 1000 domande. Un vero maestro della conoscenza biblica!',
    truth_seeker_name: 'Cercatore di verità',
    truth_seeker_description: 'Rispondi correttamente a 25 domande vero/falso.',
    binary_master_name: 'Maestro binario',
    binary_master_description: 'Rispondi correttamente a tutte le domande vero/falso in un quiz che ne contiene almeno 5.',
    lightning_judge_name: 'Giudice fulmineo',
    lightning_judge_description: 'Completa un quiz di 10 domande in meno di 2 minuti con almeno 8 risposte corrette.',
    discernment_expert_name: 'Esperto di discernimento',
    discernment_expert_description: 'Rispondi correttamente a 25 domande a selezione multipla.',
    wisdom_seeker_name: 'Cercatore di saggezza',
    wisdom_seeker_description: 'Completa 10 quiz Difficili con almeno l\'80%.',
    streak_7_name: 'Inizio Serie',
    streak_7_description: 'Mantieni una serie di 7 giorni di quiz. La costanza è la chiave!',
    streak_30_name: 'Maestro di Serie',
    streak_30_description: 'Raggiungi una serie di 30 giorni. Un mese di devozione quotidiana alla Parola!',
    streak_100_name: 'Leggenda di Serie',
    streak_100_description: 'Raggiungi una serie di 100 giorni. Il tuo impegno quotidiano è straordinario!',
    explorer_5_name: 'Esploratore',
    explorer_5_description: 'Gioca quiz in 5 diverse categorie bibliche. Esplora tutta la Scrittura!',
    explorer_20_name: 'Esploratore Biblico',
    explorer_20_description: 'Gioca quiz in 20 diverse categorie. Un vero esploratore della Parola di Dio!',
    multiplayer_first_name: 'Debutto Multigiocatore',
    multiplayer_first_description: 'Completa il tuo primo quiz biblico multigiocatore. Il ferro affila il ferro!',
    multiplayer_winner_name: 'Campione Multigiocatore',
    multiplayer_winner_description: 'Vinci un quiz multigiocatore arrivando primo!',
    multiplayer_10_name: 'Veterano Multigiocatore',
    multiplayer_10_description: 'Completa 10 quiz multigiocatore. Un competitore esperto in conoscenza biblica!',
    level_10_name: 'Studioso in Ascesa',
    level_10_description: 'Raggiungi il livello 10. La tua crescita nella conoscenza biblica è impressionante!',
    level_25_name: 'Maestro Studioso',
    level_25_description: 'Raggiungi il livello 25. Hai raggiunto un vero status di studioso!',
    xp_1000_name: 'Traguardo XP',
    xp_1000_description: 'Guadagna 1000 XP totali attraverso quiz e sfide!',
    xp_10000_name: 'Leggenda XP',
    xp_10000_description: 'Guadagna 10000 XP totali. Una quantità leggendaria di apprendimento biblico!',
    scholar_rank_name: 'Grado di Studioso',
    scholar_rank_description: 'Raggiungi il grado di Studioso attraverso dedizione e conoscenza!',
    polyglot_3_name: 'Poliglotta',
    polyglot_3_description: 'Gioca quiz in 3 lingue diverse. La Parola trascende tutte le lingue!',
  },
  ko: {
    first_quiz_name: '첫 퀴즈 완료',
    first_quiz_description: '첫 성경 퀴즈를 완료하세요. 성경 여행은 한 걸음부터 시작됩니다!',
    quiz_10_name: '퀴즈 애호가',
    quiz_10_description: '성경 퀴즈 10개를 완료하세요. 하나님의 말씀에 대한 헌신이 자라고 있습니다!',
    quiz_50_name: '퀴즈 베테랑',
    quiz_50_description: '성경 퀴즈 50개를 완료하세요. 진정한 말씀의 학생이 되어가고 있습니다!',
    quiz_100_name: '퀴즈 백부장',
    quiz_100_description: '성경 퀴즈 100개를 완료하세요. 성경에 대한 헌신이 놀랍습니다!',
    quiz_500_name: '퀴즈 전설',
    quiz_500_description: '성경 퀴즈 500개를 완료하세요. 전설적인 성경 학자입니다!',
    perfect_score_name: '만점',
    perfect_score_description: '퀴즈에서 모든 질문에 정확히 답하세요. 완벽한 승리!',
    perfect_10_name: '완벽 추구자',
    perfect_10_description: '어떤 퀴즈에서든 만점을 10번 달성하세요. 정밀함을 통한 숙달!',
    knowledge_100_name: '지식 구축자',
    knowledge_100_description: '100개의 질문에 정확히 답하세요. 성경 지식을 쌓아가세요!',
    knowledge_1000_name: '지식 마스터',
    knowledge_1000_description: '1000개의 질문에 정확히 답하세요. 성경 지식의 진정한 마스터!',
    truth_seeker_name: '진리 탐구자',
    truth_seeker_description: 'O/X 문제 25개를 맞히세요.',
    binary_master_name: 'O/X 마스터',
    binary_master_description: 'O/X 문제가 5개 이상인 퀴즈에서 O/X 문제를 모두 맞히세요.',
    lightning_judge_name: '번개 심판',
    lightning_judge_description: '10문제 퀴즈를 2분 안에 8개 이상 맞히며 완료하세요.',
    discernment_expert_name: '분별의 전문가',
    discernment_expert_description: '복수 선택 문제 25개를 맞히세요.',
    wisdom_seeker_name: '지혜 탐구자',
    wisdom_seeker_description: '어려움 난이도 퀴즈 10개를 80% 이상으로 완료하세요.',
    streak_7_name: '연속 시작',
    streak_7_description: '7일간의 퀴즈 연속 기록을 유지하세요. 꾸준함이 핵심입니다!',
    streak_30_name: '연속 마스터',
    streak_30_description: '30일 연속 기록을 달성하세요. 한 달간의 매일 말씀 묵상!',
    streak_100_name: '연속 전설',
    streak_100_description: '100일 연속 기록을 달성하세요. 매일의 헌신이 놀랍습니다!',
    explorer_5_name: '탐험가',
    explorer_5_description: '5개의 다른 성경 카테고리에서 퀴즈를 플레이하세요. 모든 성경을 탐험하세요!',
    explorer_20_name: '성경 탐험가',
    explorer_20_description: '20개의 다른 카테고리에서 퀴즈를 플레이하세요. 하나님 말씀의 진정한 탐험가!',
    multiplayer_first_name: '멀티플레이어 데뷔',
    multiplayer_first_description: '첫 멀티플레이어 성경 퀴즈를 완료하세요. 철이 철을 날카롭게 합니다!',
    multiplayer_winner_name: '멀티플레이어 챔피언',
    multiplayer_winner_description: '멀티플레이어 퀴즈에서 1등으로 우승하세요!',
    multiplayer_10_name: '멀티플레이어 베테랑',
    multiplayer_10_description: '멀티플레이어 퀴즈 10개를 완료하세요. 성경 지식의 노련한 경쟁자!',
    level_10_name: '떠오르는 학자',
    level_10_description: '레벨 10에 도달하세요. 성경 지식의 성장이 인상적입니다!',
    level_25_name: '마스터 학자',
    level_25_description: '레벨 25에 도달하세요. 진정한 학자의 지위를 달성했습니다!',
    xp_1000_name: 'XP 이정표',
    xp_1000_description: '퀴즈와 도전을 통해 총 1000 XP를 획득하세요!',
    xp_10000_name: 'XP 전설',
    xp_10000_description: '총 10000 XP를 획득하세요. 전설적인 성경 학습량!',
    scholar_rank_name: '학자 등급',
    scholar_rank_description: '헌신과 지식을 통해 학자 등급을 달성하세요!',
    polyglot_3_name: '다국어 사용자',
    polyglot_3_description: '3개의 다른 언어로 퀴즈를 플레이하세요. 말씀은 모든 언어를 초월합니다!',
  },
  tl: {
    first_quiz_name: 'Unang Quiz Nakumpleto',
    first_quiz_description: 'Kumpletuhin ang iyong unang Bible quiz. Ang bawat paglalakbay sa Banal na Kasulatan ay nagsisimula sa isang hakbang!',
    quiz_10_name: 'Mahilig sa Quiz',
    quiz_10_description: 'Kumpletuhin ang 10 Bible quiz. Lumalaki ang iyong dedikasyon sa Salita ng Diyos!',
    quiz_50_name: 'Beterano ng Quiz',
    quiz_50_description: 'Kumpletuhin ang 50 Bible quiz. Nagiging tunay kang estudyante ng Salita!',
    quiz_100_name: 'Senturyon ng Quiz',
    quiz_100_description: 'Kumpletuhin ang 100 Bible quiz. Kahanga-hanga ang iyong pangako sa Kasulatan!',
    quiz_500_name: 'Alamat ng Quiz',
    quiz_500_description: 'Kumpletuhin ang 500 Bible quiz. Ikaw ay isang alamat na iskolar ng Biblia!',
    perfect_score_name: 'Perpektong Puntos',
    perfect_score_description: 'Sagutin nang tama ang lahat ng tanong sa isang quiz. Walang kapintasan na tagumpay!',
    perfect_10_name: 'Naghahanap ng Perpeksyon',
    perfect_10_description: 'Makamit ang 10 perpektong puntos sa anumang quiz. Kahusayan sa pamamagitan ng katumpakan!',
    knowledge_100_name: 'Tagabuo ng Kaalaman',
    knowledge_100_description: 'Sagutin nang tama ang 100 tanong. Pinapatibay ang iyong kaalaman sa Biblia!',
    knowledge_1000_name: 'Maestro ng Kaalaman',
    knowledge_1000_description: 'Sagutin nang tama ang 1000 tanong. Tunay na maestro ng kaalaman sa Biblia!',
    truth_seeker_name: 'Naghahanap ng Katotohanan',
    truth_seeker_description: 'Sagutin nang tama ang 25 tanong na Tama/Mali.',
    binary_master_name: 'Master ng Tama/Mali',
    binary_master_description: 'Masagot nang tama ang lahat ng tanong na Tama/Mali sa isang quiz na may hindi bababa sa 5.',
    lightning_judge_name: 'Kidlat na Hukom',
    lightning_judge_description: 'Tapusin ang 10-tanong na quiz sa loob ng 2 minuto na may 8 o higit pang tama.',
    discernment_expert_name: 'Eksperto sa Pag-unawa',
    discernment_expert_description: 'Sagutin nang tama ang 25 tanong na maramihang pagpili.',
    wisdom_seeker_name: 'Naghahanap ng Karunungan',
    wisdom_seeker_description: 'Tapusin ang 10 Mahirap na quiz na may 80% o mas mataas.',
    streak_7_name: 'Simula ng Sunod-sunod',
    streak_7_description: 'Panatilihin ang 7-araw na sunod-sunod na quiz. Ang pagiging tuloy-tuloy ang susi!',
    streak_30_name: 'Maestro ng Sunod-sunod',
    streak_30_description: 'Abutin ang 30-araw na sunod-sunod. Isang buwan ng araw-araw na debosyon sa Salita!',
    streak_100_name: 'Alamat ng Sunod-sunod',
    streak_100_description: 'Abutin ang 100-araw na sunod-sunod. Pambihira ang iyong araw-araw na pangako!',
    explorer_5_name: 'Manlalakbay',
    explorer_5_description: 'Maglaro ng quiz sa 5 iba\'t ibang kategorya ng Biblia. Tuklasin ang buong Kasulatan!',
    explorer_20_name: 'Manlalakbay ng Biblia',
    explorer_20_description: 'Maglaro ng quiz sa 20 iba\'t ibang kategorya. Tunay na manlalakbay ng Salita ng Diyos!',
    multiplayer_first_name: 'Multiplayer na Debyu',
    multiplayer_first_description: 'Kumpletuhin ang iyong unang multiplayer na Bible quiz. Ang bakal ang nagpapatalim sa bakal!',
    multiplayer_winner_name: 'Kampeon sa Multiplayer',
    multiplayer_winner_description: 'Manalo ng multiplayer quiz sa pamamagitan ng pagtatapos sa unang lugar!',
    multiplayer_10_name: 'Beterano sa Multiplayer',
    multiplayer_10_description: 'Kumpletuhin ang 10 multiplayer na quiz. Isang bihasang kalaban sa kaalaman sa Biblia!',
    level_10_name: 'Umuusbong na Iskolar',
    level_10_description: 'Abutin ang level 10. Kahanga-hanga ang iyong paglago sa kaalaman sa Biblia!',
    level_25_name: 'Maestro Iskolar',
    level_25_description: 'Abutin ang level 25. Nakamit mo ang tunay na katayuan ng iskolar!',
    xp_1000_name: 'Milestone ng XP',
    xp_1000_description: 'Kumita ng 1000 kabuuang XP sa pamamagitan ng mga quiz at hamon!',
    xp_10000_name: 'Alamat ng XP',
    xp_10000_description: 'Kumita ng 10000 kabuuang XP. Isang alamat na dami ng pag-aaral ng Biblia!',
    scholar_rank_name: 'Ranggo ng Iskolar',
    scholar_rank_description: 'Abutin ang ranggo ng Iskolar sa pamamagitan ng dedikasyon at kaalaman!',
    polyglot_3_name: 'Poliglota',
    polyglot_3_description: 'Maglaro ng quiz sa 3 iba\'t ibang wika. Ang Salita ay lampas sa lahat ng wika!',
  },
  am: {
    first_quiz_name: 'የመጀመሪያ ጥያቄ ተጠናቀቀ',
    first_quiz_description: 'የመጀመሪያውን የመጽሐፍ ቅዱስ ጥያቄ ያጠናቅቁ። እያንዳንዱ በቅዱስ ጽሑፍ ውስጥ ያለ ጉዞ በአንድ እርምጃ ይጀምራል!',
    quiz_10_name: 'የጥያቄ አድናቂ',
    quiz_10_description: '10 የመጽሐፍ ቅዱስ ጥያቄዎችን ያጠናቅቁ። ለእግዚአብሔር ቃል ያለዎት ቁርጠኝነት እያደገ ነው!',
    quiz_50_name: 'የጥያቄ ባለሙያ',
    quiz_50_description: '50 የመጽሐፍ ቅዱስ ጥያቄዎችን ያጠናቅቁ። እውነተኛ የቃሉ ተማሪ እየሆኑ ነው!',
    quiz_100_name: 'የጥያቄ መቶ አለቃ',
    quiz_100_description: '100 የመጽሐፍ ቅዱስ ጥያቄዎችን ያጠናቅቁ። ለቅዱስ ጽሑፍ ያለዎት ቁርጠኝነት አስደናቂ ነው!',
    quiz_500_name: 'የጥያቄ አፈ ታሪክ',
    quiz_500_description: '500 የመጽሐፍ ቅዱስ ጥያቄዎችን ያጠናቅቁ። አፈ ታሪካዊ የመጽሐፍ ቅዱስ ምሁር ነዎት!',
    perfect_score_name: 'ፍጹም ውጤት',
    perfect_score_description: 'በአንድ ጥያቄ ውስጥ ሁሉንም ጥያቄዎች በትክክል ይመልሱ። ያለ ስህተት ድል!',
    perfect_10_name: 'ፍጹምነት ፈላጊ',
    perfect_10_description: 'በማንኛውም ጥያቄ ውስጥ 10 ፍጹም ውጤቶችን ያግኙ። በትክክለኝነት ማስተር!',
    knowledge_100_name: 'የእውቀት ግንቢ',
    knowledge_100_description: '100 ጥያቄዎችን በትክክል ይመልሱ። የመጽሐፍ ቅዱስ እውቀትዎን ይገንቡ!',
    knowledge_1000_name: 'የእውቀት ባለቤት',
    knowledge_1000_description: '1000 ጥያቄዎችን በትክክል ይመልሱ። እውነተኛ የመጽሐፍ ቅዱስ እውቀት ባለቤት!',
    truth_seeker_name: 'የእውነት ፈላጊ',
    truth_seeker_description: '25 እውነት/ሐሰት ጥያቄዎችን በትክክል ይመልሱ።',
    binary_master_name: 'የሁለትዮሽ ጌታ',
    binary_master_description: 'ቢያንስ 5 እውነት/ሐሰት ጥያቄዎች ባሉት ጥያቄ ሁሉንም በትክክል ይመልሱ።',
    lightning_judge_name: 'የመብረቅ ዳኛ',
    lightning_judge_description: '10 ጥያቄ ያለውን ጥያቄ ከ2 ደቂቃ በታች 8 ወይም ከዚያ በላይ በትክክል ያጠናቅቁ።',
    discernment_expert_name: 'የማስተዋል ኤክስፐርት',
    discernment_expert_description: '25 ብዙ ምርጫ ያላቸውን ጥያቄዎች በትክክል ይመልሱ።',
    wisdom_seeker_name: 'የጥበብ ፈላጊ',
    wisdom_seeker_description: '10 ከባድ ጥያቄዎችን በ80% ወይም ከዚያ በላይ ያጠናቅቁ።',
    streak_7_name: 'ተከታታይ ጅምር',
    streak_7_description: 'የ7 ቀን ተከታታይ ጥያቄ ያቆዩ። ቋሚነት ቁልፍ ነው!',
    streak_30_name: 'ተከታታይ ባለቤት',
    streak_30_description: 'የ30 ቀን ተከታታይ ያግኙ። አንድ ወር ዕለታዊ ለቃሉ መወሰን!',
    streak_100_name: 'ተከታታይ አፈ ታሪክ',
    streak_100_description: 'የ100 ቀን ተከታታይ ያግኙ። ዕለታዊ ቁርጠኝነትዎ ልዩ ነው!',
    explorer_5_name: 'አሳሽ',
    explorer_5_description: 'በ5 የተለያዩ የመጽሐፍ ቅዱስ ምድቦች ውስጥ ጥያቄ ይጫወቱ። መላውን ቅዱስ ጽሑፍ ያስሱ!',
    explorer_20_name: 'የመጽሐፍ ቅዱስ አሳሽ',
    explorer_20_description: 'በ20 የተለያዩ ምድቦች ውስጥ ጥያቄ ይጫወቱ። እውነተኛ የእግዚአብሔር ቃል አሳሽ!',
    multiplayer_first_name: 'የብዙ ተጫዋች ጅምር',
    multiplayer_first_description: 'የመጀመሪያውን የብዙ ተጫዋች የመጽሐፍ ቅዱስ ጥያቄ ያጠናቅቁ። ብረት ብረትን ይሳላል!',
    multiplayer_winner_name: 'የብዙ ተጫዋች ሻምፒዮን',
    multiplayer_winner_description: 'የብዙ ተጫዋች ጥያቄን በመጀመሪያ ደረጃ ያሸንፉ!',
    multiplayer_10_name: 'የብዙ ተጫዋች ባለሙያ',
    multiplayer_10_description: '10 የብዙ ተጫዋች ጥያቄዎችን ያጠናቅቁ። ልምድ ያለው ተወዳዳሪ!',
    level_10_name: 'እያደገ ያለ ምሁር',
    level_10_description: 'ደረጃ 10 ይድረሱ። በመጽሐፍ ቅዱስ እውቀት ውስጥ ያለዎት እድገት አስደናቂ ነው!',
    level_25_name: 'ማስተር ምሁር',
    level_25_description: 'ደረጃ 25 ይድረሱ። እውነተኛ የምሁር ደረጃ ላይ ደርሰዋል!',
    xp_1000_name: 'የXP ምዕራፍ',
    xp_1000_description: 'በጥያቄዎች እና ፈተናዎች 1000 ጠቅላላ XP ያግኙ!',
    xp_10000_name: 'የXP አፈ ታሪክ',
    xp_10000_description: '10000 ጠቅላላ XP ያግኙ። አፈ ታሪካዊ መጠን የመጽሐፍ ቅዱስ ትምህርት!',
    scholar_rank_name: 'የምሁር ደረጃ',
    scholar_rank_description: 'በቁርጠኝነት እና እውቀት የምሁር ደረጃ ይድረሱ!',
    polyglot_3_name: 'ብዙ ቋንቋ ተናጋሪ',
    polyglot_3_description: 'በ3 የተለያዩ ቋንቋዎች ጥያቄ ይጫወቱ። ቃሉ ሁሉንም ቋንቋዎች ያሻግራል!',
  },
};
